/**
 * @class AppDecorationIFrame
 * @param element HTMLIFrameElement
 * @constructor
 */
function AppDecorationIFrame(element){
	this._element = element;

	this._contentWindow = this._element.contentWindow;
	this._messageHandlerBound = this._messageHandler.bind(this);
	// Listen on current window message events
	this._element.ownerDocument.defaultView.addEventListener("message", this._messageHandlerBound, false);
	if(!this._channelOpened){
		// Force to open
		this._contentWindow.postMessage("open", "*");
		// Wait the "ready" message
	}
}
/** @type HTMLIFrameElement */
AppDecorationIFrame.prototype._element = null;
AppDecorationIFrame.prototype._contentWindow = null;
/** @type {Boolean} */
AppDecorationIFrame.prototype._channelOpened = false;
/** @type {String} */
AppDecorationIFrame.prototype._state = null;
AppDecorationIFrame.prototype._messageHandlerBound = null;

/**
 * Define load state
 * @property {Boolean} state
 */
Object.defineProperty(AppDecorationIFrame.prototype, "state", {
	/** @this {AppDecorationIFrame} */
	get: function getState(){
		return this._state;
	},
	/** @this {AppDecorationIFrame} */
	set: function setState(value){
		this._state = value;

		if(this._channelOpened){
			this._contentWindow.postMessage(this._state == "target" ? "target" : "untarget", "*");
		}
	}
});
AppDecorationIFrame.prototype._messageHandler = function _messageHandler(event){
	// Only the iframe content window
	if(event.source != this._contentWindow){
		return;
	}

	if(event.data == "wait" && !this._channelOpened){
		// Re send open message (already send but could be came too early)
		this._contentWindow.postMessage("open", "*");
	}else if(event.data == "ready"){
		this._channelOpened = true;
		this._contentWindow.postMessage(this._state == "target" ? "target" : "untarget", "*");
	}
};

AppDecorationIFrame.prototype.clear = function clear(){
	this._element.ownerDocument.defaultView.removeEventListener("message", this._messageHandlerBound, false);

	return true;
};
